<template>
    <div id="app">
        <!-- 强制要求退出 -->
        <van-overlay :show="isErr" z-index="1001">
            <div class="wrapper ">
                <div class="err">
                    <p>注册服务失败，请关闭重新进入</p>
                    <p>提示：如果微信版本过低会导致服务无法注册</p>
                </div>
            </div>
        </van-overlay>

        <!-- 全屏加载 -->
        <van-overlay :show="$root.loadingAll" z-index="10001" :custom-style="{'background-color': 'rgba(255,255,255,0)'}">
            <div class="wrapper ">
                <van-loading style="text-align: center; line-height: 100vh;" color="#409EFF" size="48px" />
            </div>
        </van-overlay>

        <!-- 读取组件 -->
        <transition :name="transitionName">
            <router-view ref="router_view" />
        </transition>
    </div>
</template>

<style lang="scss">
    html,body,#app {
        margin:0;
        padding:0;
        height: 100%;
        background: #f6f6f6;
        font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
        font-size: 14px;
        color: #323233;
    }

    .van-submit-bar {
        padding: 5px 0;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .err {
            background-color: #fff;
            padding: 20px;
            border-radius: 10px;
            text-align: center;
        }
    }

    .popup {
        height: 100%;
        width: 100%;

        .popup_title {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            padding: 14px 15px;
            border-bottom: 2px solid #409EFF;

            .van-button {
                float: right;
            }
        }

        .popup_body {
            height: calc(100vh - 60px);
            overflow-x: hidden;
            overflow-y: auto;
            background-color: #f6f6f6;
            touch-action: pan-y !important;
        }
    }

    .footer {
        padding: 15px;
        padding-bottom: 20px;
        width: calc(100% - 30px);
        position:absolute;
        bottom: 0;
    }

    .popup_tit {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        padding: 11px 20px;
        border-bottom: 2px solid #409EFF;

        .van-button {
            float: right;
        }
    }

    /*长条形按钮样式*/
    .card-option{
        margin: 20px;
        .van-button{
            margin-bottom: 10px;
        }
    }

    /*空状态提示*/
    .empty{
        margin: 20px 0;
        color: #969799;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
    }

    /*字体图标，使用symbol方式引入*/
    .icon {
        width: 1em;
        height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }

    .integral-goods-list{
        margin-top: 15px;

        .integral-goods-item{

            .van-grid-item__content{
                padding: 0;

                .integral-goods-title,
                .integral-goods-integral{
                    width: 90%;
                    margin-bottom: 5px;
                }
                .integral-goods-title{
                    text-align: left;
                    margin-top:5px;
                }
                .integral-goods-integral{
                    color: #f3094b;
                    font-size: 16px;
                    span{
                        font-size: 10px;
                        margin-left: 2px;
                    }
                }
            }
        }
    }
</style>

<script>
    import wx from 'weixin-js-sdk'
    import api from "./assets/js/api";
    import auth from "./assets/js/auth";
    import common from "./assets/js/common";

    export default {
        name: 'App',
        data () {
            return {
                isErr: false,
                showHeight: document.documentElement.clientHeigh,
                transitionName: 'van-slide-left',
                urlLog: []

            }
        },
        created() {
            let self = this;

            function wechatLogin(){
                let companyId = self.$route.params.companyId;
                let redirectUrl = window.location.origin + window.location.pathname;
                let queryArr = [];
                for(let name in self.$route.query){
                    if(name === 'token' || name === 'invite_user_id') continue;
                    queryArr.push(name + '=' + self.$route.query[name]);
                }
                redirectUrl += '?' + queryArr.join('&');
                redirectUrl = encodeURIComponent(redirectUrl);

                let param = ''
                if (!(/^[0-9]+.?[0-9]*$/.test(companyId))) {
                    param = `global_company_wechat_id=${companyId}`
                } else {
                    param = `global_company_id=${companyId}`
                }
                let url = `${api.REQUEST_URL_PREFIX}/user/wechat_login?${param}&callback_url=${redirectUrl}`;
                if(self.$route.query.invite_user_id){
                    url += '&invite_user_id=' + self.$route.query.invite_user_id;
                }
                window.location = url;
            }

            //设置全局的回调
            api.before(function (options) {
                if(auth.isLogin()){
                    if (options.data instanceof FormData) {
                        options.data.append('api_token', auth.getAuthInfo().api_token);
                    } else {
                        options.data.api_token = auth.getAuthInfo().api_token;
                    }
                }
                if (!(/^[0-9]+.?[0-9]*$/.test(self.$route.params.companyId))) {
                    if (options.data instanceof FormData) {
                        options.data.append('global_company_wechat_id', self.$route.params.companyId);
                    } else {
                        options.data.global_company_wechat_id = self.$route.params.companyId;
                    }
                } else {
                    if (options.data instanceof FormData) {
                        options.data.append('global_company_id', self.$route.params.companyId);
                    } else {
                        options.data.global_company_id = self.$route.params.companyId;
                    }
                }
            });
            api.fail(function (res) {
                if(res.code === 4001){
                    wechatLogin();
                }
            });

            if(this.$route.query.loginType === 'sms'){
                let callback_url = window.location.origin + window.location.pathname;
                let queryArr = [];
                for(let name in self.$route.query){
                    if(name === 'loginType' || name === 'invite_user_id') continue;
                    queryArr.push(name + '=' + encodeURIComponent(self.$route.query[name]));
                }
                callback_url += queryArr.length > 0 ? '?' + queryArr.join('&') : '';
                return self.$router.push({
                    name : 'SmsLogin',
                    query : {
                        callback_url : callback_url,
                        invite_user_id : self.$route.query.invite_user_id,
                    },
                });
            }else if(this.$route.query.token){
                auth.setAuthInfo({
                    api_token: this.$route.query.token,
                });
                self.$store.commit('refreshUserInfo');  //刷新用户信息
            }
            self.$store.commit('syncUserInfo');

            // 主题设置
            console.log('user theme color:' + localStorage.getItem('themeColor'))
            if (localStorage.getItem('themeColor')) {
                document.querySelector('body').setAttribute('data-theme', localStorage.getItem('themeColor'))
            } else {
                document.querySelector('body').setAttribute('data-theme', 'blue')
            }

            if(self.$route.name === 'SmsLogin' && auth.isLogin()){
                return self.$router.push({ name : 'User' });
            }else if(!auth.isLogin() && self.$route.name !== 'SmsLogin'){
                wechatLogin();
            }


        },
        mounted () {
            let self = this;

            // 动态获取手机键盘状态
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight
                    this.showHeight = window.fullHeight
                })()
            }
            self.$store.commit('refreshSystemEnum');  //获取所有枚举数据
            self.$store.commit('refreshSystemConfig');  //获取系统设置数据
            // common.wechatReady(function (data) {
            //     wx.checkJsApi({
            //         jsApiList: data.jsApiList,
            //         success: (ver) => {
            //             let isErr = false;
            //             for (let name in ver.checkResult) {
            //                 if(!ver.checkResult[name]){
            //                     isErr = true;
            //                     break;
            //                 }
            //             }
            //             self.isErr = isErr;
            //         },
            //     });
            // })
        },

        // watch监听屏幕高度变化, 控制底部按钮的显示隐藏
        watch: {
            '$route' : {
                handler(to, from) {
                    if (this.urlLog.length <= 0) {
                        this.urlLog.push(from.path)
                        this.urlLog.push(to.path)
                    } else {
                        if (this.urlLog.indexOf(to.path) >= 0) {
                            this.urlLog.splice(this.urlLog.length - 1, 1)
                            this.transitionName = 'van-slide-right'
                        } else {
                            this.urlLog.push(to.path)
                            this.transitionName = 'van-slide-left'
                        }
                    }
                },
                deep : true,
            },
            showHeight (val) {
                if (document.documentElement.clientHeight > val) {
                    this.$root.systemKeyboard = false
                } else {
                    this.$root.systemKeyboard = true
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/App.vue